"use strict";

var rootElement = null;
var selection = null;
var selectedRange = null;
var selectionChangedCallback = null;
var documentResizeCallback = null;
var mouseUpCallback = null;
var keyCallback = null;
var lastEvent = null;

function isElementWithin(elm) {
  while (elm) {
    if (elm === rootElement) return true;
    elm = elm.parentElement;
  }
  return false;
}

function isElementWithinUI(elm) {
  if (
    ["TEXTAREA", "SVG", "PATH", "INPUT", "BUTTON"].indexOf(elm.tagName) != -1
  ) {
    return true;
  }
  while (elm) {
    if (elm.className.indexOf && elm.className.indexOf("annot8-ui") != -1)
      return true;
    if (elm === rootElement) return false;
    elm = elm.parentElement;
  }
  return false;
}

/*
var disableSelection = false;
function temporarilyDisableSelection() {
  disableSelection = true;
  enableSelection();
}
var enableSelection = _.debounce(function() {
  disableSelection = false;
  onSelectionChange(null);
}, 500);
*/

function onSelectionChange(evt) {
  lastEvent = evt;
  // if (disableSelection) {
  //   return;
  // }
  /* evt is not used */

  var hasSelection = false;
  try {
    var sel = window.getSelection();
    if (sel != null) {
      if (isElementWithin(sel.anchorNode) && isElementWithin(sel.focusNode)) {
        var range = sel.getRangeAt(0);
        if (range != null) {
          // if (isElementWithin(range.commonAncestorContainer)) {
          if (range.toString() !== "") {
            hasSelection = true;
            selection = sel;
            selectedRange = range;
          }
          // }
        }
      } else {
        // temporarilyDisableSelection();
      }
    }
  } catch (err) {
    // this.log(err);
  }

  var hadSelection = selection != null;
  if (!hasSelection) {
    selection = null;
    selectedRange = null;
    if (!hadSelection) {
      return;
    }
  }

  selectionChangedCallback(selection, selectedRange);
}

function onDocumentResize() {
  documentResizeCallback();
}

function onMouseUp(evt) {
  setTimeout(function () {
    if (selection) return;

    // check within
    if (isElementWithinUI(evt.srcElement)) {
      return;
    }
    // if (isElementWithin(evt.srcElement)) {
    mouseUpCallback({
      x: evt.pageX,
      y: evt.pageY,
      sx: evt.screenX,
      sy: evt.screenY
    });
  }, 0)
  // }
}

function onTouchStart(evt) {
  setTimeout(function () {
    if (selection) return;

    // check within
    if (isElementWithinUI(evt.srcElement)) {
      return;
    }
    // if (isElementWithin(evt.srcElement)) {
    var touch = evt.changedTouches[0];
    // var touch = evt.touches[0];
    mouseUpCallback({
      x: touch.pageX,
      y: touch.pageY,
      sx: touch.screenX,
      sy: touch.screenY,
      evt: "touch"
    });
  }, 0);
  // }
}

function onKeyDown(evt) {
  if ([8, 9, 13, 27, 46, 49, 50, 51, 52, 53].indexOf(evt.keyCode) != -1) {
    keyCallback(evt.keyCode);
  }
}

function start(element, callback1, callback2, callback3, callback4) {
  rootElement = element;
  selectionChangedCallback = callback1;
  documentResizeCallback = callback2;
  mouseUpCallback = callback3;
  keyCallback = callback4;

  document.addEventListener("selectionchange", onSelectionChange);
  window.addEventListener("resize", onDocumentResize);
  rootElement.addEventListener("mouseup", onMouseUp);
  // document.body.addEventListener('touchstart', onTouchStart);
  // document.body.addEventListener('touchmove', onTouchStart);
  rootElement.addEventListener("touchend", onTouchStart);
  document.addEventListener("keydown", onKeyDown);

  // console.log("start spy");
}

function stop() {
  document.removeEventListener("selectionchange", onSelectionChange);
  window.removeEventListener("resize", onDocumentResize);
  rootElement.removeEventListener("mouseup", onMouseUp);
  // document.body.removeEventListener('touchstart', onTouchStart);
  // document.body.removeEventListener('touchmove', onTouchStart);
  rootElement.removeEventListener("touchend", onTouchStart);
  document.removeEventListener("keydown", onKeyDown);

  // console.log("stop spy");
}

export default {
  start: start,
  stop: stop,
  event: function() {
    return lastEvent;
  }
};
